module.exports = __webpack_public_path__ + "static/fonts/iconfont.6ed3fa3.woff";